<script setup lang="ts"></script>
<template>
  <div class="w-screen relative flex min-h-dvh justify-center md:justify-end items-center">
    <div
      class="absolute -z-10 left-0 top-1/2 md:top-0 md:w-1/2 w-full h-1/2 md:h-full shadow-merino-200 border-merino-200 border-t md:border-r"
    ></div>
    <div
      class="absolute -z-10 left-0 top-0 md:left-1/2 md:w-1/2 w-full h-1/2 md:h-full bg-merino-100 shadow-inner"
    ></div>
    <div
      class="md:w-screen md:h-fit h-full grid grid-cols-1 md:grid-cols-[1fr_1fr] grid-rows-[1fr_1fr] md:grid-rows-1"
    >
      <div class="col-start-1 row-start-2 md:row-start-1 px-4 md:px-6 lg:px-10">
        <slot name="left" />
      </div>
      <div class="col-start-1 row-start-1 md:row-start-1 md:col-start-2 px-4 md:px-6 lg:px-10">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>
